import { makeStyles, tokens } from '@fluentui/react-components';

export const useExternalLinkStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginLeft: `${tokens.spacingHorizontalSNudge}`,
  },
});
